export const PAGES = {
	HOMEPAGE: "homepage",
	COMPLETE: "complete"
}